<app-cards-basic title="User List">

<table mat-table [dataSource]="dataSource" multiTemplateDataRows>
  @for (column of columnsToDisplay; track column; let index = $index) {
    <ng-container matColumnDef="{{column}}">
      <th mat-header-cell *matHeaderCellDef>{{columnsHeaders[index]}}</th>
      <td mat-cell *matCellDef="let element">{{element[column]}}</td>
    </ng-container>
  }
  <ng-container matColumnDef="expand">
    <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
    <td mat-cell *matCellDef="let element">
      <button
        mat-icon-button
        aria-label="expand row"
        (click)="toggle(element); $event.stopPropagation()"
        class="example-toggle-button"
        [class.example-toggle-button-expanded]="isExpanded(element)">
        <mat-icon>
          <span class="material-symbols-outlined">keyboard_arrow_down</span>
        </mat-icon>
      </button>
    </td>
  </ng-container>

  <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
  <ng-container matColumnDef="expandedDetail">
    <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplayWithExpand.length">
      <div class="example-element-detail-wrapper" [class.example-element-detail-wrapper-expanded]="isExpanded(element)">
        <div class="example-element-detail">
          <div class="py-4">
            <h3>{{element.product_subscriptions.length}} Product Subscriptions:</h3><br>
            @for(product of element.product_subscriptions; track product; let last = $last){
              {{product.translations[currentLanguage].title}} @if(!last) {, }
            }
          </div>
        </div>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="columnsToDisplayWithExpand"></tr>
  <tr mat-row *matRowDef="let element; columns: columnsToDisplayWithExpand;"
      class="example-element-row"
      [class.example-expanded-row]="isExpanded(element)"
      (click)="toggle(element)">
  </tr>
  <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
</table>


<mat-paginator [length]="totalUsers"
               [pageSize]="pageSize"
               class="pt-4"
               [pageSizeOptions]="[5, 10, 25, 100]"
               (page)="onPageChange($event)">
</mat-paginator>

</app-cards-basic>
